import React from 'react';
import Tippy from '@tippyjs/react'; // optional
import styled from 'styled-components';
import Colors from '@components/shared/Colors';
import TooltipIcon from '@images/icon-tooltip.svg';
import 'tippy.js/dist/tippy.css';

type Props = {
  text: string;
  children?: React.ReactNode;
};

const IconWithTooltip: React.FC<Props> = ({ text, children = undefined }) => (
  <StyledTippy
    content={
      <div
        dangerouslySetInnerHTML={{
          __html: text
        }}
      />
    }
  >
    {children || (
      <TooltipButton>
        <TooltipIcon />
      </TooltipButton>
    )}
  </StyledTippy>
);

export default IconWithTooltip;

const StyledTippy = styled(Tippy)`
  font-family: 'BrownStd';
  padding: 15px 20px;
  background: ${Colors.navyBlue};
  border-radius: 2px;

  .tippy-arrow {
    color: ${Colors.navyBlue};
  }

  img {
    display: block;
    margin: 10px 0;
    width: 100%;

    &:first-child {
      margin-top: 0;
    }
  }
`;

export const TooltipButton = styled.button`
  padding: 0;
  background: transparent;
  border: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;
